export interface RegionalState {
  country: string,
  language: string,
  currency: string,
}

export const InitialRegionalState : RegionalState = {
  country: null!,
  currency: null!,
  language: null!
}